import type { PreloadedQuery } from 'react-relay';
// eslint-disable-next-line jira/import-whitelist -- Unclear how to change the config whilst we transition to flat config
import UI_CUSTOMER_DETAILS_PAGE_QUERY from '@jira/servicedesk__customer-details/src/__generated__/CustomerDetailsCustomerDetailsPageQuery$parameters.ts';
// eslint-disable-next-line jira/import-whitelist
import UI_CUSTOMER_DETAILS_PAGE_CSM_QUERY from '@jira/servicedesk__customer-details/src/__generated__/CustomerDetailsCustomerDetailsPageCsmQuery$parameters.ts';
import type { CustomerDetailsCustomerDetailsPageQuery } from '@jira/servicedesk__customer-details/src/__generated__/CustomerDetailsCustomerDetailsPageQuery.graphql.ts';
// eslint-disable-next-line jira/import-whitelist
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { RouteResource } from '@atlassian/react-resource-router';

export const CustomerDetailsPageQueryResource: RouteResource<
	PreloadedQuery<CustomerDetailsCustomerDetailsPageQuery, Record<string, unknown>>
> = createRelayResource<CustomerDetailsCustomerDetailsPageQuery>({
	type: 'UI_CUSTOMER_DETAILS_PAGE_QUERY',
	getQuery: ({ match }, { tenantContext }) => ({
		// Endpoint migration (BERRY-2444): preload the csm_ endpoint query when the
		// gate is on, else the deprecated one. The page component selects the matching
		// document via the same gate. Both share identical variables. The csm params are
		// cast to the resource's query type (the two operations Relay can't unify).
		parameters: fg('csm_native_assets_field_customer_context')
			? // oxlint-disable-next-line typescript/consistent-type-assertions, @typescript-eslint/no-explicit-any
				(UI_CUSTOMER_DETAILS_PAGE_CSM_QUERY as any)
			: UI_CUSTOMER_DETAILS_PAGE_QUERY,
		variables: {
			accountId: String(match.params.customerId),
			cloudId: tenantContext.cloudId,
		},
		options: { fetchPolicy: 'store-and-network' },
	}),
});
